import { InstallAgentPanelWebComponent } from './component/InstallAgentPanelWebComponent';
import { WEB_COMPONENT_INSTALL_AGENT_PANEL } from '../../../webcomponents.constants';

export { InstallAgentPanelWebComponent };

window.customElements.define(WEB_COMPONENT_INSTALL_AGENT_PANEL, InstallAgentPanelWebComponent);
